import React from 'react'
import {
  FormControl,
  FormControlLabel,
  FormLabel,
  Checkbox,
  FormGroup,
} from '@mui/material'
import { makeStyles } from '@mui/styles'
import clsx from 'clsx'

const useStyles = makeStyles((theme) => ({
  radioWrapper: {
    width: '100%',
    padding: theme.spacing(2),
    borderRadius: 5,
    border: `1px solid ${theme.palette.gray.main}`,
  },
  legend: {
    padding: theme.spacing(0, 0.5),
    fontSize: 15,
  },
  label: {
    fontSize: 14,
  },
  error: {
    borderColor: theme.palette.error.main,
  },
  group: {
    flexDirection: 'initial',
  },
}))

const MuiCheckBoxInput = ({ label, value, onChange, name, options, error }) => {
  const classes = useStyles()
  const hasError = Boolean(error)
  return (
    <FormControl
      component="fieldset"
      className={clsx({
        [classes.radioWrapper]: true,
        [classes.error]: hasError,
      })}
      error={hasError}
      color="primary"
    >
      <FormLabel component="legend" className={classes.legend}>
        {label}
      </FormLabel>
      <FormGroup
        aria-label="gender"
        name={name}
        value={value}
        onChange={onChange}
        className={classes.group}
      >
        {options.map((option) => (
          <FormControlLabel
            classes={{ label: classes.label }}
            key={option.value}
            value={option.value}
            control={<Checkbox />}
            label={option.label}
          />
        ))}
      </FormGroup>
    </FormControl>
  )
}
export default MuiCheckBoxInput
